// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Address from "../Restaumatic.Address/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_OldForm from "../Restaumatic.OldForm/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic_Types from "../Restaumatic.Types/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Extra from "../Specular.Dom.Extra/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Dom_Widgets_Select from "../Specular.Dom.Widgets.Select/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Utils_DynamicFixFRP from "../Utils.DynamicFixFRP/index.js";
var itemWrapper = function (name) {
    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-delivery-address__item m-delivery-address__item--" + name) ]);
};
var houseOrBlockSelect = function (initial) {
    return itemWrapper("house_or_block")(Restaumatic_OldForm.group(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Restaumatic_OldForm.NotChanged.value))(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("control-label m-form__label m-form__label--required"), Specular_Dom_Element.attr("for")("house_or_block") ])(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.house_or_block))))(function () {
        var options = [ Restaumatic_Address.House.value, Restaumatic_Address.Block.value ];
        return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-select") ])(Specular_Dom_Widgets_Select.selectInput(Specular_Dom_Widget.monadWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Builder.monadReplaceBuilder)(Specular_Dom_Builder.monoidBuilder(Data_Monoid.monoidUnit)))({
            options: options,
            initialValueIndex: Data_Maybe.fromMaybe(0)(Data_Array.findIndex(Data_Eq.eq(Restaumatic_Address.eqHouseOrBlock)(initial))(options)),
            display: Restaumatic_Address.displayHouseOrBlock,
            attributes: Control_Applicative.pure(Specular_FRP_WeakDynamic.applicativeWeakDynamic)(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("id")("house_or_block"))(Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("class")("form-control m-select__select"))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("name")("order_deliver_at"))))
        }));
    })));
};
var formField = function (v) {
    var view = function (input) {
        return Data_Functor.map(Specular_Dom_Builder.functorBuilder)(function (v1) {
            return v1.value;
        })(Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(itemWrapper(v.name)(Restaumatic_OldForm["textField$prime"](Restaumatic_OldForm.renderErrorString)({
            name: v.name,
            label: v.label,
            attrs: v.attrs,
            initialValue: v.initialValue,
            required: v.required,
            validationState: input.validationState
        })(v.overwrite))));
    };
    var control = function (value) {
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Control_Monad_Reader_Class.asks(Specular_Dom_Builder.monadAskBuilder)(function (v1) {
            return v1.forceShowValidationErrors;
        }))(function (forceShowErrors) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.holdUniqDynBy(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Eq.eq(Data_Eq.eqBoolean))(false)(Specular_FRP_Base.leftmost([ Data_Functor.voidRight(Specular_FRP_Base.functorEvent)(true)(Specular_FRP_Base.changed(value)), Specular_FRP_Base.filterEvent(Control_Category.identity(Control_Category.categoryFn))(Specular_FRP_Base.changed(forceShowErrors)) ])))(function (hasChanged) {
                var validate = function (v1) {
                    if (v1 === "" && v.required) {
                        return new Restaumatic_OldForm["Error"](Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.blank));
                    };
                    return Restaumatic_OldForm.Success.value;
                };
                var validatedValue = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
                    var $17 = Data_Eq.eq(Restaumatic_OldForm.eqValidationState(Data_Eq.eqString))(validate(v1))(Restaumatic_OldForm.Success.value);
                    if ($17) {
                        return new Data_Maybe.Just(v1);
                    };
                    return Data_Maybe.Nothing.value;
                })(value);
                var validationState = Control_Bind.bind(Specular_FRP_Base.bindDynamic)(hasChanged)(function (changed) {
                    if (changed) {
                        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(validate)(value);
                    };
                    return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Restaumatic_OldForm.NotChanged.value);
                });
                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(new Data_Tuple.Tuple({
                    validationState: validationState
                }, {
                    valid: validatedValue,
                    raw: value
                }));
            });
        });
    };
    return Utils_DynamicFixFRP.dynamicFixFRP(Utils_DynamicFixFRP.fixFRPRecord(Utils_DynamicFixFRP.dynamicFixFRPRecord({
        reflectSymbol: function () {
            return "validationState";
        }
    })()()()()(Utils_DynamicFixFRP.dynamicFixFRPDynamic)(Utils_DynamicFixFRP.dynamicFixFRPRecordNil(Type_Equality.refl)))())(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))({
        validationState: Restaumatic_OldForm.NotChanged.value
    })(Control_Bind.composeKleisli(Specular_Dom_Builder.bindBuilder)(view)(control));
};
var emptyRawDeliveryAddress = {
    street: "",
    streetNumber: "",
    city: "",
    postCode: "",
    extra: Restaumatic_Address.emptyAddressExtra
};
var defaultAptInfoWidget = function (v) {
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
        name: "apt-number",
        label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.apt_number),
        attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/aptNumber"),
        initialValue: v.aptNumber,
        required: false,
        overwrite: Specular_FRP_Base.never
    }))(function (aptNumber) {
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
            name: "floor",
            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.floor),
            attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/floor"),
            initialValue: v.floor,
            required: false,
            overwrite: Specular_FRP_Base.never
        }))(function (floor) {
            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Restaumatic_Address.AddressExtra)(Data_Record_Extra2.rsequence()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "additionalInfo";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "aptNumber";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "block";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "floor";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "houseOrBlock";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "interphone";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "sector";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                reflectSymbol: function () {
                    return "staircase";
                }
            })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()())()())()())({
                additionalInfo: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                block: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                houseOrBlock: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Restaumatic_Address.House.value),
                interphone: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                sector: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                staircase: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                aptNumber: aptNumber.raw,
                floor: floor.raw
            })));
        });
    });
};
var br = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("m-delivery-address__br") ])(Restaumatic_Prelude_Specular.wempty);
var romanianAptInfoWidget = function (v) {
    var houseOrBlockExtra = function (v1) {
        if (v1 instanceof Restaumatic_Address.Block) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                name: "block",
                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.block),
                attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/block"),
                initialValue: v.block,
                required: true,
                overwrite: Specular_FRP_Base.never
            }))(function (block) {
                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                    name: "staircase",
                    label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.staircase),
                    attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/staircase"),
                    initialValue: v.staircase,
                    required: true,
                    overwrite: Specular_FRP_Base.never
                }))(function (staircase) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                            name: "floor",
                            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.floor),
                            attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/floor"),
                            initialValue: v.floor,
                            required: true,
                            overwrite: Specular_FRP_Base.never
                        }))(function (floor) {
                            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                                name: "apt-number",
                                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.apt_number),
                                attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/aptNumber"),
                                initialValue: v.aptNumber,
                                required: true,
                                overwrite: Specular_FRP_Base.never
                            }))(function (aptNumber) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                                        name: "interphone",
                                        label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.interphone),
                                        attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/interphone"),
                                        initialValue: v.interphone,
                                        required: false,
                                        overwrite: Specular_FRP_Base.never
                                    }))(function (interphone) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                                            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Restaumatic_Address.AddressExtra)(Data_Record_Extra2.rsequence()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "additionalInfo";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "aptNumber";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "block";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "floor";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "houseOrBlock";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "interphone";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                                reflectSymbol: function () {
                                                    return "sector";
                                                }
                                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                                reflectSymbol: function () {
                                                    return "staircase";
                                                }
                                            })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()())()())()())({
                                                additionalInfo: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                                                block: block.raw,
                                                houseOrBlock: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Restaumatic_Address.Block.value),
                                                interphone: interphone.raw,
                                                sector: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(""),
                                                staircase: staircase.raw,
                                                aptNumber: aptNumber.raw,
                                                floor: floor.raw
                                            })));
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        };
        if (v1 instanceof Restaumatic_Address.House) {
            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Newtype.over()()(Restaumatic_Address.AddressExtra)(function (v2) {
                return {
                    houseOrBlock: Restaumatic_Address.House.value,
                    additionalInfo: v2.additionalInfo,
                    aptNumber: v2.aptNumber,
                    block: v2.block,
                    floor: v2.floor,
                    interphone: v2.interphone,
                    sector: v2.sector,
                    staircase: v2.staircase
                };
            })(Restaumatic_Address.emptyAddressExtra)));
        };
        throw new Error("Failed pattern match at Restaumatic.Site.Components.Address (line 238, column 3 - line 238, column 123): " + [ v1.constructor.name ]);
    };
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
        name: "sector",
        label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.sector),
        attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/sector"),
        initialValue: v.sector,
        required: false,
        overwrite: Specular_FRP_Base.never
    }))(function (sector) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Widget.liftWidget(Specular_Dom_Builder.monadDomBuilderBuilder)(houseOrBlockSelect(v.houseOrBlock)))(function (houseOrBlock) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchDynamic)(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(houseOrBlockExtra)(houseOrBlock)))(function (extra) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                            name: "additionalInfo",
                            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.additional_info),
                            attrs: Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/additionalInfo"),
                            initialValue: v.additionalInfo,
                            required: false,
                            overwrite: Specular_FRP_Base.never
                        }))(function (additionalInfo) {
                            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(sector.raw)(function (sector$prime) {
                                return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(additionalInfo.raw)(function (additionalInfo$prime) {
                                    return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(extra)(function (extra$prime) {
                                        return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Newtype.over()()(Restaumatic_Address.AddressExtra)(function (v1) {
                                            return {
                                                additionalInfo: additionalInfo$prime,
                                                sector: sector$prime,
                                                aptNumber: v1.aptNumber,
                                                block: v1.block,
                                                floor: v1.floor,
                                                houseOrBlock: v1.houseOrBlock,
                                                interphone: v1.interphone,
                                                staircase: v1.staircase
                                            };
                                        })(extra$prime));
                                    });
                                });
                            }));
                        });
                    });
                });
            });
        });
    });
};
var aptInfoWidget = function (country) {
    if (Data_Eq.eq(Restaumatic_TypesGen.eqCountry)(country)(Restaumatic_Types.countryRomania)) {
        return romanianAptInfoWidget;
    };
    if (Data_Boolean.otherwise) {
        return defaultAptInfoWidget;
    };
    throw new Error("Failed pattern match at Restaumatic.Site.Components.Address (line 147, column 1 - line 151, column 89): " + [ country.constructor.name ]);
};
var addressWidget = function (config) {
    return function (initial) {
        var updateFormattedAddress = function (cntry) {
            return function (da) {
                var newfaddr = Restaumatic_Address.formatCountrySpecificAddress(cntry)(da);
                return Data_Newtype.over()()(Restaumatic_Address.DeliveryAddress)(function (a) {
                    return {
                        formattedAddress: newfaddr,
                        aptNumber: a.aptNumber,
                        city: a.city,
                        country: a.country,
                        extra: a.extra,
                        floor: a.floor,
                        postCode: a.postCode,
                        street: a.street,
                        streetNumber: a.streetNumber
                    };
                })(da);
            };
        };
        var emptyField = Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
            valid: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just("")),
            raw: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
        });
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
            name: "street",
            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.street),
            attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("shipping address-line1"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/street")),
            initialValue: initial.street,
            required: true,
            overwrite: Data_Functor.map(Specular_FRP_Base.functorEvent)((function () {
                var $31 = Data_Newtype.unwrap();
                return function ($32) {
                    return (function (v) {
                        return v.street;
                    })($31($32));
                };
            })())(config.geocodingAddressE)
        }))(function (street) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                name: "street-number",
                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.street_number),
                attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("shipping address-line2"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/streetNumber")),
                initialValue: initial.streetNumber,
                required: true,
                overwrite: Data_Functor.map(Specular_FRP_Base.functorEvent)((function () {
                    var $33 = Data_Newtype.unwrap();
                    return function ($34) {
                        return (function (v) {
                            return v.streetNumber;
                        })($33($34));
                    };
                })())(config.geocodingAddressE)
            }))(function (streetNumber) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(formField({
                        name: "city",
                        label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.city),
                        attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("shipping address-level2"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/city")),
                        initialValue: initial.city,
                        required: true,
                        overwrite: Data_Functor.map(Specular_FRP_Base.functorEvent)((function () {
                            var $35 = Data_Newtype.unwrap();
                            return function ($36) {
                                return (function (v) {
                                    return v.city;
                                })($35($36));
                            };
                        })())(config.geocodingAddressE)
                    }))(function (city) {
                        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)((function () {
                            var $29 = Restaumatic_Address.isPostCodeRequired(config.accountId)(config.country);
                            if ($29) {
                                return formField({
                                    name: "post-code",
                                    label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.attributes.delivery_address.post_code),
                                    attrs: Data_Semigroup.append(Foreign_Object.semigroupObject(Data_Semigroup.semigroupString))(Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs)("autocomplete")("shipping postal-code"))(Specular_Dom_Extra.testId(Specular_Dom_Extra.testIdLegacyAdapterAttrs)("deliveryAddress/postCode")),
                                    initialValue: initial.postCode,
                                    required: true,
                                    overwrite: Specular_FRP_Base.never
                                });
                            };
                            return emptyField;
                        })())(function (postCode) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(br)(function () {
                                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)((function () {
                                    if (config.withAptInfo) {
                                        return aptInfoWidget(config.country)(initial.extra);
                                    };
                                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Restaumatic_Address.emptyAddressExtra));
                                })())(function (extra) {
                                    var deliveryAddrNoFormat = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_Address.DeliveryAddress))(Data_Record_Extra2.rsequence2(Specular_FRP_Base.functorDynamic)()(Data_Maybe.applicativeMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "aptNumber";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "city";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "country";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "extra";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "floor";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "formattedAddress";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "postCode";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "street";
                                        }
                                    })()(Data_Maybe.applyMaybe)(Record_Extra.sequenceRecordSingle({
                                        reflectSymbol: function () {
                                            return "streetNumber";
                                        }
                                    })()(Data_Maybe.functorMaybe)()())()())()())()())()())()())()())()())()())()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "aptNumber";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "city";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "country";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "extra";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "floor";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "formattedAddress";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "postCode";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                        reflectSymbol: function () {
                                            return "street";
                                        }
                                    })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                        reflectSymbol: function () {
                                            return "streetNumber";
                                        }
                                    })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()())()())()())()())({
                                        street: street.valid,
                                        streetNumber: streetNumber.valid,
                                        city: city.valid,
                                        postCode: postCode.valid,
                                        aptNumber: Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                                            var $37 = Data_Newtype.unwrap();
                                            return function ($38) {
                                                return Data_Maybe.Just.create((function (v) {
                                                    return v.aptNumber;
                                                })($37($38)));
                                            };
                                        })())(extra),
                                        floor: Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                                            var $39 = Data_Newtype.unwrap();
                                            return function ($40) {
                                                return Data_Maybe.Just.create((function (v) {
                                                    return v.floor;
                                                })($39($40)));
                                            };
                                        })())(extra),
                                        country: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(config.country)),
                                        extra: Data_Functor.map(Specular_FRP_Base.functorDynamic)(function ($41) {
                                            return Data_Maybe.Just.create(Data_Maybe.Just.create($41));
                                        })(extra),
                                        formattedAddress: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(Data_Maybe.Nothing.value))
                                    }));
                                    var deliveryAddr = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Maybe.functorMaybe)(updateFormattedAddress(config.country)))(deliveryAddrNoFormat);
                                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)({
                                        validAddress: deliveryAddr,
                                        rawAddress: Data_Record_Extra2.rsequence()(Specular_FRP_Base.applicativeDynamic)(Record_Extra.sequenceRecordCons({
                                            reflectSymbol: function () {
                                                return "city";
                                            }
                                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                            reflectSymbol: function () {
                                                return "extra";
                                            }
                                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                            reflectSymbol: function () {
                                                return "postCode";
                                            }
                                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                                            reflectSymbol: function () {
                                                return "street";
                                            }
                                        })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                            reflectSymbol: function () {
                                                return "streetNumber";
                                            }
                                        })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())({
                                            street: street.raw,
                                            streetNumber: streetNumber.raw,
                                            city: city.raw,
                                            postCode: postCode.raw,
                                            extra: extra
                                        })
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    };
};
export {
    addressWidget,
    emptyRawDeliveryAddress
};
//# sourceMappingURL=index.js.map
